import { FileButtonProtected } from '@components'

import { FileButtonProps } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { Scope } from '../../../../enums/scope'
import { TrackingContext } from '../../../../enums/trackingContext'
import {
  IMPORTED_INVOICE_ACCEPTED_FORMATS,
  IMPORTED_INVOICE_MAX_SIZE_IN_BYTES,
} from '../../constants/importedInvoicesUpload'
import { useImportedInvoicesUploadContext } from '../../context/ImportedInvoicesUploadContext'

type ImportedInvoicesUploadButtonProps = Pick<FileButtonProps, 'size' | 'variant'>

export const ImportedInvoicesUploadButton = ({ size, variant }: ImportedInvoicesUploadButtonProps): ReactElement => {
  const { t } = useTranslation()
  const { isUploadBlocked, isUploading, uploadFiles } = useImportedInvoicesUploadContext()

  return (
    <FileButtonProtected
      scopes={Scope.UploadsWrite}
      trackingContext={TrackingContext.Uploads}
      accept={IMPORTED_INVOICE_ACCEPTED_FORMATS}
      // `disabled` rather than `isBlocked`: `isBlocked` still fires `onClick`, which
      // `FileButtonPremium` turns into an upgrade modal on top of the open dialog.
      disabled={isUploadBlocked}
      maxSize={IMPORTED_INVOICE_MAX_SIZE_IN_BYTES}
      loading={isUploading}
      multiple
      onFilesSelect={uploadFiles}
      size={size}
      variant={variant}
    >
      {t('imported_invoices.upload.button')}
    </FileButtonProtected>
  )
}
